import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleDown ,faAngleDoubleUp } from '@fortawesome/free-solid-svg-icons'

export default function Trigger(props) {

    const TriggerCss = {
        cursor: 'pointer',
    }

    const printTriggerIcon = () => {
        return props.panelState ? faAngleDoubleUp : faAngleDoubleDown;
    }

    return (
        <div style={{textAlign: 'center'}}>
            <label onClick={props.onClick} style={TriggerCss}>{props.mfgId}
                <FontAwesomeIcon icon={printTriggerIcon()} style={{marginLeft: '5px'}} />
            </label>
        </div>
    )
}
